import { SelectFieldCP } from 'modules/fields/components/select-field/SelectFieldCP'
import { SelectFieldRegulationCP } from 'common/components/form/SelectFieldRegulationCP'
import { SelectLocationCP } from 'common/components/form/SelectLocationCP'
import React, { useEffect, useRef } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { DateRangePickerCP } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/DateRangePickerCP'
import { ColumnCP } from 'submodules/nerit-framework-ui/common/components/grid/column/ColumnCP'
import { RowCP } from 'submodules/nerit-framework-ui/common/components/grid/row/RowCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { DataAnalysisFiltersFormModel } from 'modules/locations/components/filters-data-analisys/inner/DataAnalysisFiltersFormModel'
import { WrapperSwitchFilterCP } from 'submodules/nerit-framework-ui/features/common/components/filters/wrapper-switch-filter/WrapperSwitchFilterCP'
import { SwitchCP } from 'submodules/nerit-framework-ui/common/components/form-fields/switch/SwitchCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { ChartsRequests } from 'submodules/nerit-aquatec-sdk/services/charts/ChartsRequests'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { SamplingDataResponseDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/responses/SamplingDataResponseDTO'
import { WrapperFiltersCP } from 'submodules/nerit-framework-ui/features/common/components/filters/wrapper-filters/WrapperFiltersCP'
import { useEnterKeySearch } from 'submodules/nerit-framework-ui/common/responsiveness/use-enter-key-search/UseEnterKeySearch'

interface ICPProps {
    formStateManager: IFormStateManager<DataAnalysisFiltersFormModel>
    onFilter: () => void
    isLoading?: boolean
    onSamplingDataLoaded?: () => void
}

/**
 */
export function FiltersDataAnalisysCP(props: ICPProps): JSX.Element {

    const getSamplingDataRequest = useRequest<SamplingDataResponseDTO>()
    useEffect(onGetSamplingDataRequestChange, [getSamplingDataRequest.isAwaiting])

    const samplingCodes = props.formStateManager.getFieldValue('samplingCode') as number[] | undefined
    useEffect(onSelectSampling, [JSON.stringify(samplingCodes)])

    // Guarda qual foi a ultima selecao que efetivamente disparou uma requisicao,
    // para descartar respostas que cheguem defasadas (ver observacao abaixo)
    const lastRequestedCodesRef = useRef<string>('')

    useEnterKeySearch (props.onFilter)

    /**
     */
    function onSelectSampling(): void {

        if (!samplingCodes?.length) {
            // Nenhuma campanha selecionada: limpa os pontos ja preenchidos
            props.formStateManager.changeFieldValue('locationCodes', [])
            lastRequestedCodesRef.current = ''
            return
        }

        lastRequestedCodesRef.current = JSON.stringify(samplingCodes)
        getSamplingDataRequest.runRequest(ChartsRequests.getSamplingData(samplingCodes))
    }

    /**
     */
    function onGetSamplingDataRequestChange(): void {

        if (!RequestUtils.isValidRequestReturn(getSamplingDataRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE))
            return

        // Descarta resposta se a selecao de campanhas ja mudou entre o disparo e a resposta
        const currentCodes = props.formStateManager.getFieldValue('samplingCode') as number[] | undefined
        if (JSON.stringify(currentCodes) !== lastRequestedCodesRef.current)
            return

        const result = getSamplingDataRequest.responseData!
        props.formStateManager.changeFieldValue('locationCodes', result.locations.map((location) => location.code))
        
        // Notifica que os dados da campanha foram carregados

        if (props.onSamplingDataLoaded) {
            props.onSamplingDataLoaded()
        }
    }

    return (
        <WrapperFiltersCP
            filters={
                <RowCP>
                    <ColumnCP size={7}>
                        <SelectLocationCP
                            isMany={true}
                            formStateManager={props.formStateManager}
                            fieldName={'locationCodes'}
                            isRequired={true}
                            maxTagCount={1}
                        />
                    </ColumnCP>
                    <ColumnCP size={4}>
                        <SelectFieldRegulationCP
                            isRequired={props.formStateManager.getFieldValue('forceOutsideRegulation')}
                            formStateManager={props.formStateManager}
                            fieldName={'fieldRegulationCode'}
                        />
                    </ColumnCP>
                    <ColumnCP size={5}>
                        <SelectFieldCP
                            formStateManager={props.formStateManager}
                            fieldName={'fieldCodes'}
                            isMany={true}
                            maxTagCount={1}
                        />
                    </ColumnCP>
                    <ColumnCP size={4}>
                        <DateRangePickerCP
                            showBorder={true}
                            marginTop={23}
                            fastFilter={'all'}
                            fieldName={'dateRange'}
                            formStateManager={props.formStateManager}
                        />
                    </ColumnCP>
                    <ColumnCP size={3}>
                        <WrapperSwitchFilterCP>
                            <SwitchCP
                                label={'Somente fora da norma?'}
                                labelAbove={true}
                                formStateManager={props.formStateManager}
                                fieldName={'forceOutsideRegulation'}
                            />
                        </WrapperSwitchFilterCP>
                    </ColumnCP>
                </RowCP>
            }
            filterButton={
                <ButtonCP
                    icon={'search'}
                    type={'primary'}
                    onClick={props.onFilter}
                    loading={props.isLoading}
                />
            }
        />
    )
}
